// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Regions-module__chartShadow___CAScD {
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1), 0 6px 6px rgba(0, 0, 0, 0.1), 0 0 100px rgba(0, 0, 0, 0.1);
    height: fit-content;
    padding: 1rem;
    top: 0;
    left: 0;
    display: 'block';
}

.Regions-module__regGraph___jKlVC {
    aspect-ratio: 5/2.7;
    top: 0;
    left: 0;
    display: 'block';
}

.Regions-module__regGraphNoDays___hjYbL {
    aspect-ratio: 7/1.5;
    top: 0;
    left: 0;
    display: 'block';
}


@media (min-aspect-ratio: 2) {
    .Regions-module__chartShadow___CAScD {
        padding: 0.5rem;
    }

    .Regions-module__regGraph___jKlVC {
        aspect-ratio: 5/2;
    }

    .Regions-module__regGraphNoDays___hjYbL {
        aspect-ratio: 7/1;
    }
}

/* Handle very high zoom levels (like 175%) or narrow screens */
@media (max-width: 1600px) and (min-width: 700px) {
    .Regions-module__regGraph___jKlVC {
        aspect-ratio: 5/2.4;
    }

    .Regions-module__regGraphWithFootNote___SKeCN {
        aspect-ratio: 5/2.2;
    }

}
`, "",{"version":3,"sources":["webpack://./app/components/ProofOfDeliveryLayout/Regions/Regions.module.css"],"names":[],"mappings":"AAAA;IACI,sGAAsG;IACtG,mBAAmB;IACnB,aAAa;IACb,MAAM;IACN,OAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,MAAM;IACN,OAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,MAAM;IACN,OAAO;IACP,gBAAgB;AACpB;;;AAGA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA,+DAA+D;AAC/D;IACI;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;AAEJ","sourcesContent":[".chartShadow {\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1), 0 6px 6px rgba(0, 0, 0, 0.1), 0 0 100px rgba(0, 0, 0, 0.1);\n    height: fit-content;\n    padding: 1rem;\n    top: 0;\n    left: 0;\n    display: 'block';\n}\n\n.regGraph {\n    aspect-ratio: 5/2.7;\n    top: 0;\n    left: 0;\n    display: 'block';\n}\n\n.regGraphNoDays {\n    aspect-ratio: 7/1.5;\n    top: 0;\n    left: 0;\n    display: 'block';\n}\n\n\n@media (min-aspect-ratio: 2) {\n    .chartShadow {\n        padding: 0.5rem;\n    }\n\n    .regGraph {\n        aspect-ratio: 5/2;\n    }\n\n    .regGraphNoDays {\n        aspect-ratio: 7/1;\n    }\n}\n\n/* Handle very high zoom levels (like 175%) or narrow screens */\n@media (max-width: 1600px) and (min-width: 700px) {\n    .regGraph {\n        aspect-ratio: 5/2.4;\n    }\n\n    .regGraphWithFootNote {\n        aspect-ratio: 5/2.2;\n    }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chartShadow": `Regions-module__chartShadow___CAScD`,
	"regGraph": `Regions-module__regGraph___jKlVC`,
	"regGraphNoDays": `Regions-module__regGraphNoDays___hjYbL`,
	"regGraphWithFootNote": `Regions-module__regGraphWithFootNote___SKeCN`
};
export default ___CSS_LOADER_EXPORT___;
